import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { API_BASE_URL as apiBaseUrl } from '@app/core/constants/api-base-url';
import { Subject } from 'rxjs';
const EXTERNAL_LINK_DATASET = 'c6a64ba9-711b-413a-8e72-95868f6ffbe9';

@Component({
    selector: 'topo-external-link-download',
    templateUrl: './external-link-download.component.html',
    styleUrls: ['./external-link-download.component.scss'],
    standalone: false
})
export class ExternalLinkDownloadComponent implements OnInit, OnDestroy {
  destroy$ = new Subject<void>();

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe(params => {
      const filePath = decodeURI(params['path']);
      window.location.href = `${apiBaseUrl}/v1/data/datasets/${EXTERNAL_LINK_DATASET}/files/stream/${filePath}`;
    });
  }
}
